var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgClipboardCheck(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 30,
    height: 40,
    viewBox: "0 0 30 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_1588_15502)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M26.25 5H20C20 2.24219 17.7578 0 15 0C12.2422 0 10 2.24219 10 5H3.75C1.67969 5 0 6.67969 0 8.75V36.25C0 38.3203 1.67969 40 3.75 40H26.25C28.3203 40 30 38.3203 30 36.25V8.75C30 6.67969 28.3203 5 26.25 5ZM15 3.125C16.0391 3.125 16.875 3.96094 16.875 5C16.875 6.03906 16.0391 6.875 15 6.875C13.9609 6.875 13.125 6.03906 13.125 5C13.125 3.96094 13.9609 3.125 15 3.125ZM24.4688 21.2344L13.2969 32.3125C12.9297 32.6797 12.3359 32.6719 11.9688 32.3047L5.51562 25.7969C5.14844 25.4297 5.15625 24.8359 5.52344 24.4688L7.74219 22.2656C8.10938 21.8984 8.70312 21.9062 9.07031 22.2734L12.6641 25.8984L20.9453 17.6797C21.3125 17.3125 21.9062 17.3203 22.2734 17.6875L24.4766 19.9062C24.8437 20.2812 24.8359 20.8672 24.4688 21.2344Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1588_15502"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 30,
    height: 40,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgClipboardCheck);
export default __webpack_public_path__ + "static/media/clipboardCheck.898da4a3ead45b6bc8ef11028049106c.svg";
export { ForwardRef as ReactComponent };